import { Box, Skeleton, styled } from '@mui/material';
import React from 'react';

const StyledSkeletonButton = styled(Skeleton)(({ theme }) => ({
	margin: theme.spacing(1),
	backgroundColor: theme.palette.background.default,
}));

const ResumeSkeletion = () => (
	<Box
		display="flex"
		flexDirection="column"
		minHeight="80vh"
		height="100%"
		data-testid="resume-skeleton"
	>
		<Box
			display="flex"
			justifyContent="center"
			alignItems="center"
			bgcolor="emphasis.medium"
			height={32}
			width="100%"
		>
			<StyledSkeletonButton variant="circular" height={24} width={24} />
			<StyledSkeletonButton variant="circular" height={24} width={24} />
			<StyledSkeletonButton variant="circular" height={24} width={24} />
			<StyledSkeletonButton variant="circular" height={24} width={24} />
			<StyledSkeletonButton variant="circular" height={24} width={24} />
		</Box>
		<Box
			p={2}
			display="flex"
			justifyContent="center"
			height="100%"
			minHeight="inherit"
			bgcolor="background.default"
		>
			<Skeleton variant="rectangular" height="100%" width="80%" sx={{ minHeight: 'inherit' }} />
		</Box>
	</Box>
);

export default ResumeSkeletion;
